enum EncryptDialogFields {
	OPEN_PASSWORD = "open_password",
	PERMISSION_PASSWORD = "permission_password",
	PRINTING = "printing",
	CAN_MODIFY = "can_modify",
	CAN_ASSEMBLE = "can_assemble",
	CAN_FILL_IN_FORM = "can_fill_in_form",
	CAN_MODIFY_ANNOTATIONS = "can_modify_annotations",
	CAN_EXTRACT_CONTENT = "can_extract_content",
	CAN_EXTRACT_FOR_ACCESSIBILITY = "can_extract_for_accessibility",
	KEY = "key",
	CONTENT_ENCRYPTION = "content_encryption"
}

export default EncryptDialogFields;